import constants from '@/common/constants';

class CustomValidator {
    validate(type, subject) {
        switch (type) {
            case 'file': return this.file(subject); break;
        }
    }

    file(document) {
        let errors = [];
        if (document.size/1024 > constants.MAX_UPLOAD_SIZE) {
            errors.push(`File exceeds maximum upload size of ${constants.NICE_MAX_UPLOAD_SIZE}`)
        }
        return errors;
    }
}

const Validator = new CustomValidator();
export default Validator;